var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShapeC(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 343,
    viewBox: "0 0 236 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171.469 202.786V139.597L117.234 108L63 139.597V202.786L117.234 234.383L171.469 202.786Z",
    stroke: "#D0556D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.469 309.786V246.597L55.2343 215L1 246.597V309.786L55.2343 341.383L109.469 309.786Z",
    stroke: "#D0556D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.469 96.7861V33.5972L55.2343 2L1 33.5972V96.7861L55.2343 128.383L109.469 96.7861Z",
    stroke: "#D0556D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M234.469 96.7861V33.5972L180.234 2L126 33.5972V96.7861L180.234 128.383L234.469 96.7861Z",
    stroke: "#D0556D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeC);
export default __webpack_public_path__ + "static/media/shape-c.3723adf3.svg";
export { ForwardRef as ReactComponent };